import React from 'react';
import { useDispatch, useSelector } from 'react-redux'

import EmailQuote from 'pu-react/components/EmailQuoteValidates';
import PriceMatrices from './price/PriceMatrices';

import { selectFabricationDataForPrices } from '../selector/selectors';

import { priceSelected, doEmailQuote } from '../fabricationSlice';

const Prices = () => {
  const dispatch = useDispatch();
  
  const {
    quote,
    quoteStep,
    parameters,
    parametersChanged,
  } = useSelector(selectFabricationDataForPrices)

  const onPriceSelect = (data) => dispatch(priceSelected(data));
  const onSendEmailQuote = (data, token) => dispatch(doEmailQuote({ data, token }));

  const supplierInfos = Spree.supplier_infos || [];
  
  return (
    <div className="pcb-price-section">
      <div className="text-end bg-white pt-4 pe-4">
        <EmailQuote
          quoteStep={quoteStep}
          parametersChanged={parametersChanged}
          parameters={parameters}
          onSendEmailQuote={onSendEmailQuote}/>
      </div>
      <PriceMatrices
        quote={quote}
        quoteStep={quoteStep}
        parametersChanged={parametersChanged}
        parameters={parameters}
        supplierInfos={supplierInfos}
        onPriceSelect={onPriceSelect}/>
    </div>
  );
}

export default Prices;
